import format from "date-fns/format";

export default function isDateBeforeServiceCreated(
  dateOfIssue: string | Date,
  serviceCreated: string | Date
): boolean {
  if (!dateOfIssue || dateOfIssue == "0000-00-00") return true;

  const dateOfIssueFormat = format(new Date(dateOfIssue), "yyyy-MM-dd");
  const serviceCreatedFormat = format(new Date(serviceCreated), "yyyy-MM-dd");

  const bool =
    new Date(dateOfIssueFormat).getTime() >=
    new Date(serviceCreatedFormat).getTime();
  if (!bool) {
    alert("指定発行日は不正です。サービス期間内で入力してください");

    return false;
  }

  return true;
}
